import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type"

export const byStops = (state: FlightState, flight: TypeFlight) => {
  const filterStops = state.flightsResult.filters.stops || []
  if (filterStops.length <= 0) {
    return true
  }
  return filterStops.some(stop => {
    if (stop === 0) {
      return flight.stopNumber === 0
    }

    if (stop === 1) {
      return flight.stopNumber === 1
    }

    if (stop === -1) {
      return flight.stopNumber > 1
    }
  })
}